// src/App.js
import React from "react";
import NavBar from "../components/NavBar/NavBar.jsx";
import Footer from "../components/Footer/Footer.jsx";
import EventDetailPage from "../components/Profile/EventsAndSpaces/Events/EventDetailPage.jsx";
import Search from "../components/SearchArea/Search.jsx";

// import './index.css';

export default function EventDetailsPage() {
  return (
    <div>
      <NavBar />
      <EventDetailPage />
      {/* <Search pageType="eventPage" /> */}
    </div>
  );
}
